export default "__VITE_ASSET__BnJ$oJMD__"